// extracted by mini-css-extract-plugin
module.exports = {"CooperationChannel":"index-module_CooperationChannel_23SRo","rightIcon":"index-module_rightIcon_qLHnX"};